import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api.ts';
import { useDebouncedValue } from '../../lib/hooks.ts';
import type { SearchResponse } from './types.ts';

export const RECORD_SEARCH_MIN_CHARS = 2;

/** Global record search (`GET /api/search`): debounced, min 2 characters, aborted when the query changes. */
export function useRecordSearch(query: string, enabled: boolean) {
  const q = useDebouncedValue(query.trim(), 250);
  const active = enabled && Array.from(q).length >= RECORD_SEARCH_MIN_CHARS;
  const result = useQuery({
    queryKey: ['search', q],
    queryFn: ({ signal }) => api.get<SearchResponse>('/api/search', { query: { q, limit: 5 }, signal }),
    enabled: active,
    staleTime: 15_000,
    placeholderData: keepPreviousData,
  });
  const settled = query.trim() === q;
  return { ...result, active, settled, data: active ? result.data : undefined };
}
